export default __webpack_public_path__ + "static/14-c85361eb9a914da4dd2deaab0ac8d32d.jpg";